module.exports = __webpack_public_path__ + "static/media/power-off.fb7a7651.svg";